var $9153fe570822488b$exports = {};
$9153fe570822488b$exports = {
    "collectionLabel": `Suggestions`
};


export {$9153fe570822488b$exports as default};
//# sourceMappingURL=fr-FR.module.js.map
